// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   Form,
//   Button,
//   Table,
//   Pagination,
//   Badge,
//   Modal,
//   FloatingLabel,
//   InputGroup,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";
// import {
//   FaFilter as FaFilterIcon,
//   FaStar,
//   FaPhoneAlt,
//   FaEdit,
//   FaTimes,
//   FaCheck,
//   FaTrash,
// } from "react-icons/fa";
// import "../SupportReport/AdminReports.css";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;
// const STATUS_OPTIONS = ["new", "in_review", "resolved"];
// const PRIORITY_OPTIONS = ["low", "normal", "high", "urgent"];

// const truncate = (s, n = 80) => (s && s.length > n ? s.slice(0, n) + "…" : s || "");

// const fmtDate = (d) => {
//   const dt = new Date(d);
//   if (isNaN(dt)) return "-";
//   const dd = String(dt.getDate()).padStart(2, "0");
//   const m = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][dt.getMonth()];
//   const yyyy = dt.getFullYear();
//   return `${dd}-${m}-${yyyy}`;
// };
// const fmtTime = (d) => {
//   const dt = new Date(d);
//   if (isNaN(dt)) return "-";
//   return dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
// };

// const ContactList = () => {
//   const [rows, setRows] = useState([]);
//   const [meta, setMeta] = useState({ page: 1, limit: DEFAULT_LIMIT, total: 0, totalPages: 1 });

//   // Filters
//   const [search, setSearch] = useState("");
//   const [status, setStatus] = useState("All");
//   const [priority, setPriority] = useState("All");
//   const [important, setImportant] = useState("All");
//   const [contacted, setContacted] = useState("All");

//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(1);

//   const [selected, setSelected] = useState(null);
//   const [showView, setShowView] = useState(false);
//   const [showEdit, setShowEdit] = useState(false);

//   // edit fields
//   const [editStatus, setEditStatus] = useState("new");
//   const [editPriority, setEditPriority] = useState("normal");
//   const [editImportant, setEditImportant] = useState(false);
//   const [editContacted, setEditContacted] = useState(false);
//   const [editNotes, setEditNotes] = useState("");
//   const [savingEdit, setSavingEdit] = useState(false);

//   // selection
//   const [selectedIds, setSelectedIds] = useState(new Set());
//   const [selectAllPage, setSelectAllPage] = useState(false);

//   const sortBy = "created_at";
//   const sortDir = "DESC";

//   const fetchContacts = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       const { data } = await axios.get(`${URL}/admin/contacts`, {
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//         params: {
//           page,
//           limit: DEFAULT_LIMIT,
//           q: search,
//           status: status === "All" ? "" : status,
//           priority: priority === "All" ? "" : priority,
//           isImportant: important === "All" ? "" : important === "Yes",
//           contacted: contacted === "All" ? "" : contacted === "Yes",
//           sortBy,
//           sortDir,
//         },
//       });
//       const newRows = Array.isArray(data?.data) ? data.data : [];
//       setRows(newRows);
//       setMeta({
//         page: data?.page || 1,
//         limit: data?.limit || DEFAULT_LIMIT,
//         total: data?.total || 0,
//         totalPages: data?.totalPages || 1,
//       });

//       // clean selected ids when records disappear
//       setSelectedIds((prev) => {
//         const next = new Set([...prev].filter((id) => newRows.some((r) => r.Id === id)));
//         return next;
//       });

//       // adjust select-all checkbox for current page
//       setSelectAllPage(
//         newRows.length > 0 && newRows.every((r) => selectedIds.has(r.Id))
//       );
//     } catch (e) {
//       console.error("Failed to load contacts:", e);
//       setRows([]);
//       setMeta({ page: 1, limit: DEFAULT_LIMIT, total: 0, totalPages: 1 });
//       setSelectedIds(new Set());
//       setSelectAllPage(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchContacts();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page, search, status, priority, important, contacted]);

//   const totalPages = meta.totalPages || 1;
//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);
//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   const badgeForStatus = (s) => `adminReports-badge adminReports-badge-${(s || "new").toLowerCase()}`;
//   const badgeForPriority = (p) => `adminReports-pill adminReports-pill-${(p || "normal").toLowerCase()}`;

//   const openView = (row) => { setSelected(row); setShowView(true); };
//   const openEdit = (row) => {
//     setSelected(row);
//     setEditStatus(row.status || "new");
//     setEditPriority(row.priority || "normal");
//     setEditImportant(Boolean(row.isImportant));
//     setEditContacted(Boolean(row.contacted));
//     setEditNotes(row.adminNotes || "");
//     setShowEdit(true);
//   };
//   const closeEdit = () => { setShowEdit(false); setSelected(null); };

//   // Toggle "important" / "contacted" quickly
//   const quickToggle = async (row, field) => {
//     try {
//       const token = localStorage.getItem("token");
//       const payload = {};
//       if (field === "isImportant") payload.isImportant = !row.isImportant;
//       if (field === "contacted") payload.contacted = !row.contacted;

//       const { data } = await axios.patch(`${URL}/admin/contacts/${row.Id}`, payload, {
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });

//       // optimistic update
//       setRows((prev) => prev.map((r) => (r.Id === row.Id ? data.data : r)));
//     } catch (e) {
//       console.error("Toggle failed", e);
//       alert("Update failed");
//     }
//   };

//   const saveEdit = async () => {
//     if (!selected) return;
//     try {
//       setSavingEdit(true);
//       const token = localStorage.getItem("token");
//       const payload = {
//         status: editStatus,
//         priority: editPriority,
//         isImportant: editImportant,
//         contacted: editContacted,
//         adminNotes: editNotes,
//       };
//       const { data } = await axios.patch(`${URL}/admin/contacts/${selected.Id}`, payload, {
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });
//       setRows((prev) => prev.map((r) => (r.Id === selected.Id ? data.data : r)));
//       closeEdit();
//     } catch (e) {
//       console.error(e);
//       alert(
//         e?.response?.data?.message ||
//           e?.response?.data?.error ||
//           "Failed to update contact"
//       );
//     } finally {
//       setSavingEdit(false);
//     }
//   };

//   // selection handlers
//   const toggleSelect = (id) => {
//     setSelectedIds((prev) => {
//       const next = new Set(prev);
//       if (next.has(id)) next.delete(id);
//       else next.add(id);

//       // update select-all (page) checkbox state
//       const pageAll = rows.length > 0 && rows.every((r) => next.has(r.Id));
//       setSelectAllPage(pageAll);
//       return next;
//     });
//   };

//   const toggleSelectAllOnPage = () => {
//     setSelectedIds((prev) => {
//       const next = new Set(prev);
//       if (selectAllPage) {
//         // unselect all on this page
//         rows.forEach((r) => next.delete(r.Id));
//         setSelectAllPage(false);
//       } else {
//         // select all on this page
//         rows.forEach((r) => next.add(r.Id));
//         setSelectAllPage(true);
//       }
//       return next;
//     });
//   };

//   const canBulkDelete = selectedIds.size > 0;

//   // delete handlers
//   const deleteOne = async (row) => {
//     if (!window.confirm(`Delete message from "${row.name}"? This cannot be undone.`)) return;
//     try {
//       const token = localStorage.getItem("token");
//       await axios.delete(`${URL}/admin/contacts/${row.Id}`, {
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });
//       // refresh or optimistic update
//       setRows((prev) => prev.filter((r) => r.Id !== row.Id));
//       setSelectedIds((prev) => {
//         const next = new Set(prev);
//         next.delete(row.Id);
//         return next;
//       });
//     } catch (e) {
//       console.error("Delete failed", e);
//       alert("Failed to delete");
//     }
//   };

//   const deleteSelected = async () => {
//     if (!canBulkDelete) return;
//     if (!window.confirm(`Delete ${selectedIds.size} selected message(s)? This cannot be undone.`)) return;
//     try {
//       const token = localStorage.getItem("token");
//       const ids = Array.from(selectedIds);
//       await axios.post(`${URL}/admin/contacts/bulk-delete`, { ids }, {
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });

//       // optimistic
//       setRows((prev) => prev.filter((r) => !selectedIds.has(r.Id)));
//       setSelectedIds(new Set());
//       setSelectAllPage(false);
//     } catch (e) {
//       console.error("Bulk delete failed", e);
//       alert("Bulk delete failed");
//     }
//   };

//   return (
//     <Container fluid className="adminReports-container">
//       <Card className="adminReports-card">
//         <Card.Body>
//           <Card.Header className="adminReports-header">
//             <div className="d-flex justify-content-between align-items-center">
//               <h4 className="adminReports-title mb-0">Contact Messages</h4>
//             </div>

//             <div className="adminReports-actionsbar">
//               <Button
//                 variant="danger"
//                 size="sm"
//                 onClick={deleteSelected}
//                 disabled={!canBulkDelete}
//                 title={canBulkDelete ? "Delete selected" : "Select rows to delete"}
//               >
//                 <FaTrash style={{ marginRight: 6 }} />
//                 Delete Selected ({selectedIds.size})
//               </Button>
//             </div>
//           </Card.Header>

//           {/* Filters */}
//           <Row className="align-items-center g-2 mb-3">
//             <Col lg={4}>
//               <InputGroup>
//                 <Form.Control
//                   placeholder="Search by name/email/phone/message…"
//                   value={search}
//                   onChange={(e) => { setSearch(e.target.value); setPage(1); }}
//                   className="adminReports-search"
//                 />
//                 <InputGroup.Text className="adminReports-search-ico">
//                   <FaFilterIcon />
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={status}
//                 onChange={(e) => { setStatus(e.target.value); setPage(1); }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Status</option>
//                 {STATUS_OPTIONS.map((s) => (
//                   <option key={s} value={s}>{s.replaceAll("_", " ")}</option>
//                 ))}
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={priority}
//                 onChange={(e) => { setPriority(e.target.value); setPage(1); }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Priority</option>
//                 {PRIORITY_OPTIONS.map((p) => (
//                   <option key={p} value={p}>{p}</option>
//                 ))}
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={important}
//                 onChange={(e) => { setImportant(e.target.value); setPage(1); }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Importance</option>
//                 <option value="Yes">Important</option>
//                 <option value="No">Not Important</option>
//               </Form.Select>
//             </Col>
//             <Col lg={2}>
//               <Form.Select
//                 value={contacted}
//                 onChange={(e) => { setContacted(e.target.value); setPage(1); }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Contacted</option>
//                 <option value="Yes">Contacted</option>
//                 <option value="No">Not Contacted</option>
//               </Form.Select>
//             </Col>
//           </Row>
          

//           {/* Table */}
//           <Table striped bordered hover responsive className="adminReports-table">
//             <thead>
//               <tr>
//                 <th style={{ width: 44, textAlign: "center" }}>
//                   <Form.Check
//                     type="checkbox"
//                     checked={selectAllPage}
//                     onChange={toggleSelectAllOnPage}
//                     title="Select all on this page"
//                   />
//                 </th>
//                 <th>#</th>
//                 <th>Person</th>
//                 <th>Message</th>
//                 <th>Status</th>
//                 <th>Priority</th>
//                 <th>Important</th>
//                 <th>Contacted</th>
//                 <th>Created</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!loading && rows.map((r, idx) => {
//                 const checked = selectedIds.has(r.Id);
//                 return (
//                   <tr key={r.Id}>
//                     <td style={{ textAlign: "center" }}>
//                       <Form.Check
//                         type="checkbox"
//                         checked={checked}
//                         onChange={() => toggleSelect(r.Id)}
//                         aria-label={`Select row ${r.Id}`}
//                       />
//                     </td>
//                     <td>{(meta.page - 1) * meta.limit + idx + 1}</td>
//                     <td>
//                       <div className="adminReports-cell-main" style={{ flexDirection: "column", alignItems: "flex-start" }}>
//                         <span className="adminReports-strong">{r.name}</span>
//                         <span className="adminReports-muted">{r.phone}</span>
//                         <span className="adminReports-muted">{r.email}</span>
//                       </div>
//                     </td>
//                     <td title={r.message}>{truncate(r.message, 90)}</td>
//                     <td>
//                       <Badge className={badgeForStatus(r.status)}>{r.status.replaceAll("_"," ")}</Badge>
//                     </td>
//                     <td>
//                       <span className={badgeForPriority(r.priority)}>{r.priority}</span>
//                     </td>
//                     <td style={{ textAlign: "center" }}>
//                       <Button
//                         size="sm"
//                         variant={r.isImportant ? "warning" : "outline-secondary"}
//                         className="adminReports-action-btn"
//                         onClick={() => quickToggle(r, "isImportant")}
//                         title={r.isImportant ? "Unmark important" : "Mark important"}
//                       >
//                         <FaStar />
//                       </Button>
//                     </td>
//                     <td style={{ textAlign: "center" }}>
//                       <Button
//                         size="sm"
//                         variant={r.contacted ? "success" : "outline-secondary"}
//                         className="adminReports-action-btn"
//                         onClick={() => quickToggle(r, "contacted")}
//                         title={r.contacted ? "Mark not contacted" : "Mark contacted"}
//                       >
//                         <FaPhoneAlt />
//                       </Button>
//                     </td>
//                     <td>
//                       <div className="adminReports-datetime">
//                         <div className="adminReports-date">Date: {fmtDate(r.created_at || r.createdAt)}</div>
//                         <div className="adminReports-time">Time: {fmtTime(r.created_at || r.createdAt)}</div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="adminReports-actions">
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => openView(r)}
//                           title="View"
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-edit"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => openEdit(r)}
//                           title="Edit"
//                         >
//                           <FaEdit size={14} />
//                         </Button>
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => deleteOne(r)}
//                           title="Delete"
//                         >
//                           <FaTrash size={14} />
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//               {!loading && rows.length === 0 && (
//                 <tr><td colSpan={10} style={{ textAlign: "center" }}>No contact messages found.</td></tr>
//               )}
//               {loading && (
//                 <tr><td colSpan={10} style={{ textAlign: "center" }}>Loading…</td></tr>
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination */}
//           <Pagination className="mt-3">
//             <Pagination.First onClick={() => setPage(1)} disabled={meta.page === 1} />
//             <Pagination.Prev onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={meta.page === 1} />
//             {getPageItems(totalPages, meta.page).map((item, i) =>
//               item === "start-ellipsis" || item === "end-ellipsis" ? (
//                 <Pagination.Ellipsis key={item + i} disabled />
//               ) : (
//                 <Pagination.Item key={item} active={item === meta.page} onClick={() => setPage(item)}>
//                   {item}
//                 </Pagination.Item>
//               )
//             )}
//             <Pagination.Next
//               onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//               disabled={meta.page === meta.totalPages}
//             />
//             <Pagination.Last onClick={() => setPage(meta.totalPages)} disabled={meta.page === meta.totalPages} />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* View Modal */}
//       <Modal show={showView} onHide={() => setShowView(false)} centered size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>View Contact Message</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selected && (
//             <>
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <div className="adminReports-detail-card">
//                     <h3 className="adminReports-detail-title">Sender</h3>
//                     <p className="adminReports-detail-text">Name</p>
//                     <p className="adminReports-detail-value">{selected.name}</p>
//                     <p className="adminReports-detail-text">Email</p>
//                     <p className="adminReports-detail-value">{selected.email}</p>
//                     <p className="adminReports-detail-text">Phone</p>
//                     <p className="adminReports-detail-value">{selected.phone}</p>
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="adminReports-detail-card">
//                     <h3 className="adminReports-detail-title">Meta</h3>
//                     <div className="adminReports-summary">
//                       <Badge className={badgeForStatus(selected.status)}>{selected.status}</Badge>
//                       <span className={badgeForPriority(selected.priority)}>{selected.priority}</span>
//                       {selected.isImportant ? <span className="adminReports-chip">Important</span> : null}
//                       {selected.contacted ? <span className="adminReports-chip">Contacted</span> : null}
//                     </div>
//                     <p className="adminReports-detail-text">Submitted</p>
//                     <p className="adminReports-detail-value">
//                       {fmtDate(selected.created_at || selected.createdAt)} {fmtTime(selected.created_at || selected.createdAt)}
//                     </p>
//                     <p className="adminReports-detail-text">IP</p>
//                     <p className="adminReports-detail-value">{selected.ip || "-"}</p>
//                     <p className="adminReports-detail-text">User Agent</p>
//                     <p className="adminReports-detail-value">{selected.userAgent || "-"}</p>
//                   </div>
//                 </Col>
//               </Row>

//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">Message</h3>
//                 <p className="adminReports-detail-value" style={{ whiteSpace: "pre-wrap" }}>
//                   {selected.message}
//                 </p>
//               </div>

//               {selected.adminNotes && (
//                 <div className="adminReports-detail-card">
//                   <h3 className="adminReports-detail-title">Admin Notes</h3>
//                   <p className="adminReports-detail-value" style={{ whiteSpace: "pre-wrap" }}>
//                     {selected.adminNotes}
//                   </p>
//                 </div>
//               )}
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="success" onClick={() => setShowView(false)}>
//             <FaCheck /> Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Modal */}
//       <Modal show={showEdit} onHide={closeEdit} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Contact</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selected && (
//             <>
//               <Form.Group className="mb-2">
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select value={editStatus} onChange={(e) => setEditStatus(e.target.value)}>
//                   {STATUS_OPTIONS.map((s) => (
//                     <option key={s} value={s}>{s.replaceAll("_"," ")}</option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>

//               <Form.Group className="mb-2">
//                 <Form.Label>Priority</Form.Label>
//                 <Form.Select value={editPriority} onChange={(e) => setEditPriority(e.target.value)}>
//                   {PRIORITY_OPTIONS.map((p) => (
//                     <option key={p} value={p}>{p}</option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>

//               <Row className="mb-2">
//                 <Col md={6}>
//                   <Form.Check
//                     type="switch"
//                     id="important-switch"
//                     label="Mark as important"
//                     checked={editImportant}
//                     onChange={(e) => setEditImportant(e.target.checked)}
//                   />
//                 </Col>
//                 <Col md={6}>
//                   <Form.Check
//                     type="switch"
//                     id="contacted-switch"
//                     label="Contacted"
//                     checked={editContacted}
//                     onChange={(e) => setEditContacted(e.target.checked)}
//                   />
//                 </Col>
//               </Row>

//               <FloatingLabel label="Admin Notes (internal)">
//                 <Form.Control
//                   as="textarea"
//                   style={{ height: 140 }}
//                   value={editNotes}
//                   onChange={(e) => setEditNotes(e.target.value)}
//                 />
//               </FloatingLabel>
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="light" onClick={closeEdit} disabled={savingEdit}>
//             <FaTimes /> Cancel
//           </Button>
//           <Button variant="success" onClick={saveEdit} disabled={savingEdit}>
//             {savingEdit ? "Saving…" : "Save"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default ContactList;







// ***** Upper code is okay, update this with Auth Protect (2-Dec-2025) ***** //
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Table,
  Pagination,
  Badge,
  Modal,
  FloatingLabel,
  InputGroup,
} from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import {
  FaFilter as FaFilterIcon,
  FaStar,
  FaPhoneAlt,
  FaEdit,
  FaTimes,
  FaCheck,
  FaTrash,
} from "react-icons/fa";
import "../SupportReport/AdminReports.css";
import { URL } from "../../../config";

const DEFAULT_LIMIT = 10;
const STATUS_OPTIONS = ["new", "in_review", "resolved"];
const PRIORITY_OPTIONS = ["low", "normal", "high", "urgent"];

const truncate = (s, n = 80) =>
  (s && s.length > n ? s.slice(0, n) + "…" : s || "");

const fmtDate = (d) => {
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  const dd = String(dt.getDate()).padStart(2, "0");
  const m = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ][dt.getMonth()];
  const yyyy = dt.getFullYear();
  return `${dd}-${m}-${yyyy}`;
};
const fmtTime = (d) => {
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  return dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

const ContactList = () => {
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
  });

  // Filters
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [priority, setPriority] = useState("All");
  const [important, setImportant] = useState("All");
  const [contacted, setContacted] = useState("All");

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  const [selected, setSelected] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  // edit fields
  const [editStatus, setEditStatus] = useState("new");
  const [editPriority, setEditPriority] = useState("normal");
  const [editImportant, setEditImportant] = useState(false);
  const [editContacted, setEditContacted] = useState(false);
  const [editNotes, setEditNotes] = useState("");
  const [savingEdit, setSavingEdit] = useState(false);

  // selection
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [selectAllPage, setSelectAllPage] = useState(false);

  const sortBy = "created_at";
  const sortDir = "DESC";

  const fetchContacts = async () => {
    try {
      setLoading(true);
      const adminToken = localStorage.getItem("adminToken");

      const { data } = await axios.get(`${URL}/admin/contacts`, {
        headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        params: {
          page,
          limit: DEFAULT_LIMIT,
          q: search,
          status: status === "All" ? "" : status,
          priority: priority === "All" ? "" : priority,
          isImportant: important === "All" ? "" : important === "Yes",
          contacted: contacted === "All" ? "" : contacted === "Yes",
          sortBy,
          sortDir,
        },
      });

      const newRows = Array.isArray(data?.data) ? data.data : [];
      setRows(newRows);
      setMeta({
        page: data?.page || 1,
        limit: data?.limit || DEFAULT_LIMIT,
        total: data?.total || 0,
        totalPages: data?.totalPages || 1,
      });

      // clean selected ids when records disappear
      setSelectedIds((prev) => {
        const next = new Set(
          [...prev].filter((id) => newRows.some((r) => r.Id === id))
        );
        return next;
      });

      // adjust select-all checkbox for current page
      setSelectAllPage(
        newRows.length > 0 && newRows.every((r) => selectedIds.has(r.Id))
      );
    } catch (e) {
      console.error("Failed to load contacts:", e);
      setRows([]);
      setMeta({ page: 1, limit: DEFAULT_LIMIT, total: 0, totalPages: 1 });
      setSelectedIds(new Set());
      setSelectAllPage(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search, status, priority, important, contacted]);

  const totalPages = meta.totalPages || 1;
  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);
    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1))
      start = Math.max(2, total - (maxButtons - 2));
    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  const badgeForStatus = (s) =>
    `adminReports-badge adminReports-badge-${(s || "new").toLowerCase()}`;
  const badgeForPriority = (p) =>
    `adminReports-pill adminReports-pill-${(p || "normal").toLowerCase()}`;

  const openView = (row) => {
    setSelected(row);
    setShowView(true);
  };
  const openEdit = (row) => {
    setSelected(row);
    setEditStatus(row.status || "new");
    setEditPriority(row.priority || "normal");
    setEditImportant(Boolean(row.isImportant));
    setEditContacted(Boolean(row.contacted));
    setEditNotes(row.adminNotes || "");
    setShowEdit(true);
  };
  const closeEdit = () => {
    setShowEdit(false);
    setSelected(null);
  };

  // Toggle "important" / "contacted" quickly
  const quickToggle = async (row, field) => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      const payload = {};
      if (field === "isImportant") payload.isImportant = !row.isImportant;
      if (field === "contacted") payload.contacted = !row.contacted;

      const { data } = await axios.patch(
        `${URL}/admin/contacts/${row.Id}`,
        payload,
        {
          headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        }
      );

      // optimistic update
      setRows((prev) => prev.map((r) => (r.Id === row.Id ? data.data : r)));
    } catch (e) {
      console.error("Toggle failed", e);
      alert("Update failed");
    }
  };

  const saveEdit = async () => {
    if (!selected) return;
    try {
      setSavingEdit(true);
      const adminToken = localStorage.getItem("adminToken");
      const payload = {
        status: editStatus,
        priority: editPriority,
        isImportant: editImportant,
        contacted: editContacted,
        adminNotes: editNotes,
      };
      const { data } = await axios.patch(
        `${URL}/admin/contacts/${selected.Id}`,
        payload,
        {
          headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        }
      );
      setRows((prev) => prev.map((r) => (r.Id === selected.Id ? data.data : r)));
      closeEdit();
    } catch (e) {
      console.error(e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          "Failed to update contact"
      );
    } finally {
      setSavingEdit(false);
    }
  };

  // selection handlers
  const toggleSelect = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);

      // update select-all (page) checkbox state
      const pageAll = rows.length > 0 && rows.every((r) => next.has(r.Id));
      setSelectAllPage(pageAll);
      return next;
    });
  };

  const toggleSelectAllOnPage = () => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (selectAllPage) {
        // unselect all on this page
        rows.forEach((r) => next.delete(r.Id));
        setSelectAllPage(false);
      } else {
        // select all on this page
        rows.forEach((r) => next.add(r.Id));
        setSelectAllPage(true);
      }
      return next;
    });
  };

  const canBulkDelete = selectedIds.size > 0;

  // delete handlers
  const deleteOne = async (row) => {
    if (
      !window.confirm(
        `Delete message from "${row.name}"? This cannot be undone.`
      )
    )
      return;
    try {
      const adminToken = localStorage.getItem("adminToken");
      await axios.delete(`${URL}/admin/contacts/${row.Id}`, {
        headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
      });
      // refresh or optimistic update
      setRows((prev) => prev.filter((r) => r.Id !== row.Id));
      setSelectedIds((prev) => {
        const next = new Set(prev);
        next.delete(row.Id);
        return next;
      });
    } catch (e) {
      console.error("Delete failed", e);
      alert("Failed to delete");
    }
  };

  const deleteSelected = async () => {
    if (!canBulkDelete) return;
    if (
      !window.confirm(
        `Delete ${selectedIds.size} selected message(s)? This cannot be undone.`
      )
    )
      return;
    try {
      const adminToken = localStorage.getItem("adminToken");
      const ids = Array.from(selectedIds);
      await axios.post(
        `${URL}/admin/contacts/bulk-delete`,
        { ids },
        {
          headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        }
      );

      // optimistic
      setRows((prev) => prev.filter((r) => !selectedIds.has(r.Id)));
      setSelectedIds(new Set());
      setSelectAllPage(false);
    } catch (e) {
      console.error("Bulk delete failed", e);
      alert("Bulk delete failed");
    }
  };

  return (
    <Container fluid className="adminReports-container">
      <Card className="adminReports-card">
        <Card.Body>
          <Card.Header className="adminReports-header">
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="adminReports-title mb-0">Contact Messages</h4>
            </div>

            <div className="adminReports-actionsbar">
              <Button
                variant="danger"
                size="sm"
                onClick={deleteSelected}
                disabled={!canBulkDelete}
                title={canBulkDelete ? "Delete selected" : "Select rows to delete"}
              >
                <FaTrash style={{ marginRight: 6 }} />
                Delete Selected ({selectedIds.size})
              </Button>
            </div>
          </Card.Header>

          {/* Filters */}
          <Row className="align-items-center g-2 mb-3">
            <Col lg={4}>
              <InputGroup>
                <Form.Control
                  placeholder="Search by name/email/phone/message…"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                  className="adminReports-search"
                />
                <InputGroup.Text className="adminReports-search-ico">
                  <FaFilterIcon />
                </InputGroup.Text>
              </InputGroup>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Status</option>
                {STATUS_OPTIONS.map((s) => (
                  <option key={s} value={s}>
                    {s.replaceAll("_", " ")}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={priority}
                onChange={(e) => {
                  setPriority(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Priority</option>
                {PRIORITY_OPTIONS.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={important}
                onChange={(e) => {
                  setImportant(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Importance</option>
                <option value="Yes">Important</option>
                <option value="No">Not Important</option>
              </Form.Select>
            </Col>
            <Col lg={2}>
              <Form.Select
                value={contacted}
                onChange={(e) => {
                  setContacted(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Contacted</option>
                <option value="Yes">Contacted</option>
                <option value="No">Not Contacted</option>
              </Form.Select>
            </Col>
          </Row>

          {/* Table */}
          <Table
            striped
            bordered
            hover
            responsive
            className="adminReports-table"
          >
            <thead>
              <tr>
                <th style={{ width: 44, textAlign: "center" }}>
                  <Form.Check
                    type="checkbox"
                    checked={selectAllPage}
                    onChange={toggleSelectAllOnPage}
                    title="Select all on this page"
                  />
                </th>
                <th>#</th>
                <th>Person</th>
                <th>Message</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Important</th>
                <th>Contacted</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                rows.map((r, idx) => {
                  const checked = selectedIds.has(r.Id);
                  return (
                    <tr key={r.Id}>
                      <td style={{ textAlign: "center" }}>
                        <Form.Check
                          type="checkbox"
                          checked={checked}
                          onChange={() => toggleSelect(r.Id)}
                          aria-label={`Select row ${r.Id}`}
                        />
                      </td>
                      <td>{(meta.page - 1) * meta.limit + idx + 1}</td>
                      <td>
                        <div
                          className="adminReports-cell-main"
                          style={{
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                        >
                          <span className="adminReports-strong">{r.name}</span>
                          <span className="adminReports-muted">{r.phone}</span>
                          <span className="adminReports-muted">{r.email}</span>
                        </div>
                      </td>
                      <td title={r.message}>{truncate(r.message, 90)}</td>
                      <td>
                        <Badge className={badgeForStatus(r.status)}>
                          {r.status.replaceAll("_", " ")}
                        </Badge>
                      </td>
                      <td>
                        <span className={badgeForPriority(r.priority)}>
                          {r.priority}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Button
                          size="sm"
                          variant={
                            r.isImportant ? "warning" : "outline-secondary"
                          }
                          className="adminReports-action-btn"
                          onClick={() => quickToggle(r, "isImportant")}
                          title={
                            r.isImportant
                              ? "Unmark important"
                              : "Mark important"
                          }
                        >
                          <FaStar />
                        </Button>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Button
                          size="sm"
                          variant={
                            r.contacted ? "success" : "outline-secondary"
                          }
                          className="adminReports-action-btn"
                          onClick={() => quickToggle(r, "contacted")}
                          title={
                            r.contacted
                              ? "Mark not contacted"
                              : "Mark contacted"
                          }
                        >
                          <FaPhoneAlt />
                        </Button>
                      </td>
                      <td>
                        <div className="adminReports-datetime">
                          <div className="adminReports-date">
                            Date:{" "}
                            {fmtDate(r.created_at || r.createdAt)}
                          </div>
                          <div className="adminReports-time">
                            Time:{" "}
                            {fmtTime(r.created_at || r.createdAt)}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="adminReports-actions">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="adminReports-action-btn"
                            onClick={() => openView(r)}
                            title="View"
                          >
                            <BsEye size={16} />
                          </Button>
                          <Button
                            variant="outline-edit"
                            size="sm"
                            className="adminReports-action-btn"
                            onClick={() => openEdit(r)}
                            title="Edit"
                          >
                            <FaEdit size={14} />
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="adminReports-action-btn"
                            onClick={() => deleteOne(r)}
                            title="Delete"
                          >
                            <FaTrash size={14} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={10} style={{ textAlign: "center" }}>
                    No contact messages found.
                  </td>
                </tr>
              )}
              {loading && (
                <tr>
                  <td colSpan={10} style={{ textAlign: "center" }}>
                    Loading…
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          <Pagination className="mt-3">
            <Pagination.First
              onClick={() => setPage(1)}
              disabled={meta.page === 1}
            />
            <Pagination.Prev
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={meta.page === 1}
            />
            {getPageItems(totalPages, meta.page).map((item, i) =>
              item === "start-ellipsis" || item === "end-ellipsis" ? (
                <Pagination.Ellipsis key={item + i} disabled />
              ) : (
                <Pagination.Item
                  key={item}
                  active={item === meta.page}
                  onClick={() => setPage(item)}
                >
                  {item}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={meta.page === meta.totalPages}
            />
            <Pagination.Last
              onClick={() => setPage(meta.totalPages)}
              disabled={meta.page === meta.totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>

      {/* View Modal */}
      <Modal
        show={showView}
        onHide={() => setShowView(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>View Contact Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <>
              <Row className="mb-3">
                <Col md={6}>
                  <div className="adminReports-detail-card">
                    <h3 className="adminReports-detail-title">Sender</h3>
                    <p className="adminReports-detail-text">Name</p>
                    <p className="adminReports-detail-value">
                      {selected.name}
                    </p>
                    <p className="adminReports-detail-text">Email</p>
                    <p className="adminReports-detail-value">
                      {selected.email}
                    </p>
                    <p className="adminReports-detail-text">Phone</p>
                    <p className="adminReports-detail-value">
                      {selected.phone}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="adminReports-detail-card">
                    <h3 className="adminReports-detail-title">Meta</h3>
                    <div className="adminReports-summary">
                      <Badge className={badgeForStatus(selected.status)}>
                        {selected.status}
                      </Badge>
                      <span className={badgeForPriority(selected.priority)}>
                        {selected.priority}
                      </span>
                      {selected.isImportant ? (
                        <span className="adminReports-chip">Important</span>
                      ) : null}
                      {selected.contacted ? (
                        <span className="adminReports-chip">Contacted</span>
                      ) : null}
                    </div>
                    <p className="adminReports-detail-text">Submitted</p>
                    <p className="adminReports-detail-value">
                      {fmtDate(selected.created_at || selected.createdAt)}{" "}
                      {fmtTime(selected.created_at || selected.createdAt)}
                    </p>
                    <p className="adminReports-detail-text">IP</p>
                    <p className="adminReports-detail-value">
                      {selected.ip || "-"}
                    </p>
                    <p className="adminReports-detail-text">User Agent</p>
                    <p className="adminReports-detail-value">
                      {selected.userAgent || "-"}
                    </p>
                  </div>
                </Col>
              </Row>

              <div className="adminReports-detail-card">
                <h3 className="adminReports-detail-title">Message</h3>
                <p
                  className="adminReports-detail-value"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {selected.message}
                </p>
              </div>

              {selected.adminNotes && (
                <div className="adminReports-detail-card">
                  <h3 className="adminReports-detail-title">Admin Notes</h3>
                  <p
                    className="adminReports-detail-value"
                    style={{ whiteSpace: "pre-wrap" }}
                  >
                    {selected.adminNotes}
                  </p>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowView(false)}>
            <FaCheck /> Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEdit} onHide={closeEdit} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <>
              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                >
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>
                      {s.replaceAll("_", " ")}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Priority</Form.Label>
                <Form.Select
                  value={editPriority}
                  onChange={(e) => setEditPriority(e.target.value)}
                >
                  {PRIORITY_OPTIONS.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Row className="mb-2">
                <Col md={6}>
                  <Form.Check
                    type="switch"
                    id="important-switch"
                    label="Mark as important"
                    checked={editImportant}
                    onChange={(e) => setEditImportant(e.target.checked)}
                  />
                </Col>
                <Col md={6}>
                  <Form.Check
                    type="switch"
                    id="contacted-switch"
                    label="Contacted"
                    checked={editContacted}
                    onChange={(e) => setEditContacted(e.target.checked)}
                  />
                </Col>
              </Row>

              <FloatingLabel label="Admin Notes (internal)">
                <Form.Control
                  as="textarea"
                  style={{ height: 140 }}
                  value={editNotes}
                  onChange={(e) => setEditNotes(e.target.value)}
                />
              </FloatingLabel>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={closeEdit} disabled={savingEdit}>
            <FaTimes /> Cancel
          </Button>
          <Button variant="success" onClick={saveEdit} disabled={savingEdit}>
            {savingEdit ? "Saving…" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ContactList;
